import { createAction } from '@reduxjs/toolkit';

export const giveCredentialsAfterSignupAction = createAction<{
  username: string;
  password: string;
}>('entity/signin/give-signup-credentials');
